export type Language = 'en' | 'pt';

export interface TranslationKey {
    en: string;
    pt: string;
}

export interface Translations {
    [key: string]: TranslationKey;
}

export interface LanguageInfo {
    code: Language;
    flag: string;
    text: string;
    name: string;
}

export const LANGUAGES: Record<Language, LanguageInfo> = {
    en: {
        code: 'en',
        flag: '🇬🇧',
        text: 'EN',
        name: 'English'
    },
    pt: {
        code: 'pt',
        flag: '🇵🇹',
        text: 'PT',
        name: 'Português'
    }
};

// Helper function to get the language info for the opposite language (for toggle button)
export const getToggleLanguageInfo = (currentLanguage: Language): LanguageInfo => {
    const oppositeLanguage: Language = currentLanguage === 'en' ? 'pt' : 'en';
    return LANGUAGES[oppositeLanguage];
};

